module.exports = __webpack_public_path__ + "static/media/RP-Illustration.208c7f6d.svg";